import axios from 'axios';
import { VERSION, REQUEST_TIME_OUT } from '../config';
import { MessageT } from '../lib/REST/types';
import {
	isSuccessRequest,
	sendResponse,
	SUCCESS,
	sendErrorResponse,
	NOT_VALID,
	NO_RESPONSE,
	ERROR,
	getPublicApiUrl,
} from '../lib/REST/utils';

const DESKTOP = 'desktop';
const MOBILE = 'mobile';

function getDeviceType(isMobile: boolean = false): string {
	return isMobile ? MOBILE : DESKTOP;
}

async function fetchDataFromApi({
	environment = '',
	clientId = '',
	location = '',
	sessionId = '',
	userId = '',
	isMobile = false,
	previewQuery = {},
	requestTimeout = REQUEST_TIME_OUT,
}: {
	environment: string;
	clientId: string;
	location: string;
	sessionId: string;
	userId: string;
	isMobile: boolean;
	requestTimeout: number;
	previewQuery?: object;
}): Promise<MessageT> {
	try {
		const apiURL = getPublicApiUrl({ environment });
		const deviceType = getDeviceType(isMobile);

		const jsonResponse = await axios.get(apiURL, {
			headers: {
				'X-RMC-Client-ID': clientId,
				'X-RMC-Location': location,
				'X-RMC-Session': sessionId,
				'X-RMC-User': userId,
				'X-RMC-SDK-Version': VERSION,
				Accept: 'application/json',
			},
			params: {
				device: deviceType,
				...previewQuery,
			},
			timeout: requestTimeout,
			withCredentials: false,
		});
		const { status, data } = jsonResponse;

		if (isSuccessRequest(status)) {
			return sendResponse(SUCCESS, data);
		}

		return sendErrorResponse(NOT_VALID, jsonResponse, 1);
	} catch (e: any) {
		if (e.response) {
			return sendErrorResponse(NOT_VALID, e.message, 1);
		}

		if (e.request) {
			return sendErrorResponse(NO_RESPONSE, e.message, 1);
		}

		return sendErrorResponse(ERROR, e.message, 1);
	}
}

export async function getBlocks({
	environment,
	clientId,
	location,
	isMobile,
	sessionId,
	userId,
	previewQuery,
	requestTimeout,
}: any): Promise<MessageT> {
	const blocks = await fetchDataFromApi({
		environment,
		clientId,
		location,
		isMobile,
		sessionId,
		userId,
		previewQuery,
		requestTimeout,
	});
	return blocks;
}
